export default __webpack_public_path__ + "media/cancel-w.bf082c4a.svg";